import "./../audit complet/simulation/simulation.css";
import { useState, useContext, useEffect } from "react";
import { FaBuilding, FaGlobe, FaIdBadge, FaPrint, FaSave, FaUndo, FaMoneyBillWave, FaShieldAlt, FaCog, FaRobot, FaChartLine } from "react-icons/fa";
import Button from "components/ui/controls/button/button";
import ActionButton from "components/ui/controls/action-button";
import CardBox from "components/ui/controls/card-box/card-box";
import InfoMessage from "components/ui/controls/info-message/info-message";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Modal from "components/ui/modal/modal";
import { AppContext } from "components/app/RemExprertProvider";
import { applyFormat } from "components/ui/ui-helpers";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import TextField from "components/ui/controls/text-field/text-field";
import CheckBox from "components/ui/controls/check-box/check-box";
import { ApplySignedFormat } from "components/app/ApplySignedFormat";
import Pager from "components/ui/controls/pager/pager";
import DropDown from "components/ui/controls/drop-down/drop-down";
import { caisse } from "components/app/RemExpertIntialState";
import ParamCarcdsf from "components/app/AuditComplet/SituationPro/ParamCaisse/ParamCarcdsf";
import ParamCarmf from "components/app/AuditComplet/SituationPro/ParamCaisse/ParamCarmf";
import ParamCarpimko from "components/app/AuditComplet/SituationPro/ParamCaisse/ParamCarpimko";
import ParamCarpv from "components/app/AuditComplet/SituationPro/ParamCaisse/ParamCarpv";
import ParamCavec from "components/app/AuditComplet/SituationPro/ParamCaisse/ParamCavec";
import ParamCavp from "components/app/AuditComplet/SituationPro/ParamCaisse/ParamCavp";
import ParamCnbf from "components/app/AuditComplet/SituationPro/ParamCaisse/ParamCnbf";
import ParamCrn from "components/app/AuditComplet/SituationPro/ParamCaisse/ParamCrn";
import ParamMsa from "components/app/AuditComplet/SituationPro/ParamCaisse/ParamMsa";
import ParamLpaPageModal from "pages/audit complet/situation professionnelle/modules/parametre lpa modal";
import ParamFicheDePaiePageModal from "pages/audit complet/situation professionnelle/modules/parametre fiche de paie modal";
import DetailTNSPageModal from "pages/audit complet/résultat/detail/rémuneration/detailTNSPager";
import DetailSalariePageModal from "pages/audit complet/résultat/detail/rémuneration/detailSalariePager";
import RemExpressOptimisationRemunerationTns from "components/app/AuditRemuneration/Optimisation/RemExpressOptimisationRemunerationTns";
import RemExpressOptimisationRemunerationSalarie from "components/app/AuditRemuneration/Optimisation/RemExpressOptimisationRemunerationSalarie";
import RemExpressOptimisationResAvtIS from "components/app/AuditRemuneration/Optimisation/RemExpressOptimisationResAvtIS";
import RemExpressOptimisationRevenus from "components/app/AuditRemuneration/Optimisation/RemExpressOptimisationRevenus";
import { GestionnaireScenarioPptx } from "components/app/Api/Rapport/ApiRapport";
import ParamCavamac from "components/app/AuditComplet/SituationPro/ParamCaisse/ParamCavamac";
import { CompactFinancialCardTwoColumn } from "components/app/AuditRemuneration/Resultat/CompactFinancialCard";
// import DetailTNSPageModal from "./detail/rémuneration/detailTNSPager";
// import DetailSalariePageModal from "./detail/rémuneration/detailSalariePager";
// import DropDown from "components/ui/controls/drop-down/drop-down";
// import { AuditCompletWord } from "components/app/Api/Rapport/ApiRapport";

const RemExpressOptiRemPage = (props) => {
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalSave, setModalSave] = useState(false);
  const [modalOptimum, setModalOptimum] = useState(false);
  const [modalChgtStatut, setModalChgtStatut] = useState(false);
  const Periode = context.state.OptiRemPeriodeActuelle === undefined ? undefined : context.state.OptiRemPeriodeActuelle[0];
  const Prenom = context.state.Prenom;
  useEffect(() => {
    // context.handleCalculOptiRem("cout_entreprise", "OptiRemCoutEntreprise" + ClientConjoint, ClientConjoint, ResultatTNS, context.state["OptiRemCoutEntreprise" + ClientConjoint]);
  }, []);
  //AVANT
  let cotProductiveRetraiteObligatoireAvant = 0;

  cotProductiveRetraiteObligatoireAvant =
    ResultatTNS.state.RemExpressRemuneration?.InfosRemuneration.Rapport.RetraiteObligatoire === undefined
      ? 0
      : ResultatTNS.state.RemExpressRemuneration?.InfosRemuneration.Rapport.RetraiteObligatoire;

  let cotProductiveRetraiteFacultativeAvant = 0;
  cotProductiveRetraiteFacultativeAvant = isNaN(
    Number(ResultatTNS.state.RemExpressRemuneration?.InfosRemuneration.Rapport.RetraiteFacultative) +
      Number(ResultatTNS.state.RemExpressRemuneration?.InfosRemuneration.Rapport.TotalPEEProductif) +
      Number(ResultatTNS.state.RemExpressRemuneration?.InfosRemuneration.Rapport.TotalPERCOProductif)
  )
    ? 0
    : ResultatTNS.state.RemExpressRemuneration?.InfosRemuneration.Rapport.RetraiteFacultative +
      ResultatTNS.state.RemExpressRemuneration?.InfosRemuneration.Rapport.TotalPEEProductif +
      ResultatTNS.state.RemExpressRemuneration?.InfosRemuneration.Rapport.TotalPERCOProductif;

  //APRES
  let cotProductiveRetraiteObligatoireApres = 0;

  cotProductiveRetraiteObligatoireApres =
    ResultatTNS.state.OptiRemRemuneration?.InfosRemuneration?.Rapport?.RetraiteObligatoire === undefined
      ? 0
      : ResultatTNS.state.OptiRemRemuneration?.InfosRemuneration?.Rapport?.RetraiteObligatoire;

  let cotProductiveRetraiteFacultativeApres = 0;
  cotProductiveRetraiteFacultativeApres = isNaN(
    Number(ResultatTNS.state.OptiRemRemuneration?.InfosRemuneration?.Rapport?.RetraiteFacultative) +
      Number(ResultatTNS.state.OptiRemRemuneration?.InfosRemuneration?.Rapport?.TotalPEEProductif) +
      Number(ResultatTNS.state.OptiRemRemuneration?.InfosRemuneration?.Rapport?.TotalPERCOProductif)
  )
    ? 0
    : ResultatTNS.state.OptiRemRemuneration?.InfosRemuneration.Rapport.RetraiteFacultative +
      ResultatTNS.state.OptiRemRemuneration?.InfosRemuneration.Rapport.TotalPEEProductif +
      ResultatTNS.state.OptiRemRemuneration?.InfosRemuneration.Rapport.TotalPERCOProductif;

  return (
    <>
      <Column fill>
        <Row>
          <Column fill style={{ minWidth: "640px", maxWidth: "820px" }}>
            <CardBox
              bpad
              className=" light-title blockRoundedForce"
              style={{
                background: "linear-gradient(135deg, rgb(30, 60, 114) 0%, rgb(45, 85, 140) 50%, rgb(60, 110, 166) 100%)",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(30, 60, 114, 0.3), 0 2px 6px rgba(0,0,0,0.1)",
                border: "1px solid rgba(255,255,255,0.2)",
                color: "#ffffff",
              }}
            >
              <table className="simulation">
                <tbody>
                  <tr>
                    <td className="libelle" style={{ width: "360px" }}>
                      <div
                        style={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "8px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      ></div>
                      <span style={{ fontWeight: "500", color: "#ffffff" }}></span>
                    </td>
                    <td className="origine" style={{ color: "#ffffff" }}>
                      Situation d'origine
                    </td>
                    <td className="space" style={{ width: "50px" }}></td>
                    <td className="nouvelle" style={{ textAlign: "center", color: "#ffffff" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: "flex-end" }}>Nouvelle situation</div>
                    </td>
                    <td className="ecart" style={{ color: "#ffffff" }}>Ecart</td>
                  </tr>
                </tbody>
              </table>
            </CardBox>
            <CardBox
              bpad
              className=" blockRoundedForce"
              style={{
                background: "linear-gradient(135deg, rgb(30, 60, 114) 0%, rgb(45, 85, 140) 50%, rgb(60, 110, 166) 100%)",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(30, 60, 114, 0.3), 0 2px 6px rgba(0,0,0,0.1)",
                border: "1px solid rgba(255,255,255,0.2)",
                color: "#ffffff",
              }}
            >
              <table className="simulation">
                <tbody>
                  <tr>
                    <td className="libelle" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <div
                        className="resultat-header-card-icon-container"
                        style={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "8px",
                          background: "rgba(255,255,255,0.2)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                        }}
                      >
                        <FaBuilding style={{ color: "#ffffff", fontSize: "12px" }} />
                      </div>
                      <span style={{ fontWeight: "500", color: "#ffffff" }}>Enveloppe entreprise</span>
                    </td>
                    <td className="origine" style={{ color: "#ffffff" }}>
                      {applyFormat(context.state.RemExpressCoutEntreprise, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                    </td>
                    <td className="space"></td>
                    <td className="nouvelle" style={{ textAlign: "center", color: "#ffffff" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: "flex-end" }}>
                        <span>{applyFormat(context.state.OptiRemCoutEntreprise, "uint", { thousands: " ", decimal: ",", unit: " €" })}</span>
                        <CheckBox
                          checked={true}
                          unchecked={false}
                          value={context.state.OptiRemUnlockCoutEntreprise}
                          onChange={context.handleCheckChange("OptiRemUnlockCoutEntreprise")}
                          style={{ margin: "0", padding: "0" }}
                        />
                      </div>
                    </td>
                    <td className="ecart" style={{ color: "#ffffff" }}>
                      {ApplySignedFormat(Number(context.state.OptiRemCoutEntreprise) - Number(context.state.RemExpressCoutEntreprise))}
                    </td>
                  </tr>
                </tbody>
              </table>
            </CardBox>

            {Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel" ? (
              <RemExpressOptimisationRemunerationTns Prenom={Prenom} />
            ) : (
              <RemExpressOptimisationRemunerationSalarie Prenom={Prenom} />
            )}
            {(Periode?.Statut !== "TNS individuel" || Periode?.ModeExercice === "IS") && <RemExpressOptimisationResAvtIS Periode={context.state["PeriodeActuelle"][0]} Prenom={Prenom} />}

            <RemExpressOptimisationRevenus
              Revenus={context.state.RemExpressRevPercus}
              AutresRevenus={ResultatTNS.state.DetailImpot?.AutresRevenusFoyer}
              IRTotal={ResultatTNS.state.DetailImpot?.IRTotal}
              CotisationsFacPerso={context.state.RemExpressCotFacPerso}
            />
            <CardBox
              bpad
              className=" blockRoundedForce"
              style={{
                background: "linear-gradient(135deg, rgb(30, 60, 114) 0%, rgb(45, 85, 140) 50%, rgb(60, 110, 166) 100%)",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(34, 197, 94, 0.3), 0 2px 6px rgba(0,0,0,0.1)",
                border: "1px solid rgba(255,255,255,0.2)",
                color: "#ffffff",
              }}
            >
              <table className="simulation">
                <tbody>
                  <tr>
                    <td className="libelle" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <div
                        className="resultat-header-card-icon-container"
                        style={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "8px",
                          background: "rgba(255,255,255,0.2)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                        }}
                      >
                        <FaMoneyBillWave style={{ color: "#ffffff", fontSize: "12px" }} />
                      </div>
                      <span style={{ fontWeight: "500", color: "#ffffff" }}>Revenu disponible</span>
                    </td>
                    <td className="origine" style={{ color: "#ffffff" }}>
                      {applyFormat(context.state.RemExpressRevDispo, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                    </td>
                    <td className="space"></td>
                    <td className="nouvelle" style={{ color: "#ffffff" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: "flex-end" }}>
                        <TextField
                          value={context.state.OptiRemRevDispo}
                          onChange={(e) => {
                            context.handleCalculOptiRem("revenu_dispo", "OptiRemRevDispo", "", ResultatTNS, false, e);
                          }}
                          dataType="uint"
                          format={{ thousands: " ", unit: " €" }}
                          style={{
                            height: "28px",
                            width: "110px",
                            padding: "0 8px",
                            backgroundColor: "#e0f2fe",
                            border: "1px solid #b3e5fc",
                            borderRadius: "6px",
                            textAlign: "right",
                            fontSize: "12px",
                            fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                            fontWeight: "400",
                            color: "#0277bd",
                            transition: "all 0.2s ease",
                          }}
                        />
                      </div>
                    </td>
                    <td className="ecart" style={{ color: "#ffffff" }}>
                      
                      {ApplySignedFormat(Number(context.state.OptiRemRevDispo) - Number(context.state.RemExpressRevDispo))}
                    </td>
                  </tr>
                </tbody>
              </table>
            </CardBox>
            <CardBox
              bpad
              className=" blockRoundedForce"
              style={{
                background: "linear-gradient(135deg, rgb(30, 60, 114) 0%, rgb(45, 85, 140) 50%, rgb(60, 110, 166) 100%)",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(124, 58, 237, 0.3), 0 2px 6px rgba(0,0,0,0.1)",
                border: "1px solid rgba(255,255,255,0.2)",
                color: "#ffffff",
              }}
            >
              <table className="simulation">
                <tbody>
                  <tr>
                    <td className="libelle" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <div
                        className="resultat-header-card-icon-container"
                        style={{
                          width: "24px",
                          height: "24px",
                          borderRadius: "8px",
                          background: "rgba(255,255,255,0.2)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                        }}
                      >
                        <FaShieldAlt style={{ color: "#ffffff", fontSize: "12px" }} />
                      </div>
                      <span style={{ fontWeight: "500", color: "#ffffff" }}>Cotisations productives de retraite</span>
                    </td>
                    <td className="origine" style={{ color: "#ffffff" }}>
                      {applyFormat(cotProductiveRetraiteObligatoireAvant + cotProductiveRetraiteFacultativeAvant, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                    </td>
                    <td className="space"></td>
                    <td className="nouvelle pr4" style={{ color: "#ffffff" }}>
                      {applyFormat(cotProductiveRetraiteObligatoireApres + cotProductiveRetraiteFacultativeApres, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                    </td>
                    <td className="ecart" style={{ color: "#ffffff" }}>
                      
                      {ApplySignedFormat(
                        cotProductiveRetraiteObligatoireApres + cotProductiveRetraiteFacultativeApres - (cotProductiveRetraiteObligatoireAvant + cotProductiveRetraiteFacultativeAvant)
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </CardBox>
          </Column>

          <Column fill style={{ minWidth: "465px",maxWidth: "520px" }}>
          
            <Row>
              <Column fill>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    padding: "12px",
                    background: "linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(248,250,252,0.98) 100%)",
                    borderRadius: "12px",
                    boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                    border: "1px solid rgba(255,255,255,0.9)",
                  }}
                >
                  {/* Titre du deuxième groupe */}
                  <div
                    style={{
                      fontSize: "12px",
                      fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                      fontWeight: 600,
                      color: "#1f2937",
                      marginBottom: "4px",
                      letterSpacing: "-0.02em",
                      borderBottom: "1px solid rgba(0,0,0,0.1)",
                      paddingBottom: "8px",
                    }}
                  >
                    Analyses et simulations
                  </div>
                  {/* Première ligne - 2 boutons */}
                  <div style={{ display: "flex", gap: "8px" }}>
                    <ActionButton
                      variant="primary"
                      icon={<FaCog />}
                      title={`Détails ${Prenom}`}
                      subtitle="Charges sociales et impôt"
                      onClick={() => setModalDetail(true)}
                    />
                    
                  </div>
                  {/* Deuxième ligne - 2 boutons */}
                  <div style={{ display: "flex", gap: "8px" }}>
                    {(Periode?.Statut !== "TNS individuel" || Periode?.ModeExercice === "IS") && (
                      <ActionButton
                        variant="info"
                        icon={<FaChartLine />}
                        title="Optimum"
                        subtitle="Arbitrage prime / dividendes"
                        onClick={() => setModalOptimum(true)}
                      />
                    )}
                    
                    {(Periode?.Statut === "TNS Article 62" || Periode?.Statut === "Assimilé salarié" || (Periode?.Statut === "TNS individuel" && Periode?.ModeExercice === "IR")) && (
                      <ActionButton
                        variant="success"
                        icon={<FaIdBadge />}
                        title="Changement de statut"
                        subtitle="Simuler un nouveau statut"
                        onClick={() => {
                          setModalChgtStatut(true);
                        }}
                      />
                    )}
                  </div>
                </div>
              </Column>
            </Row>

            {/* Cotisations productives en matière de retraite - Carte blanche détaillée */}
            <div
              style={{
                background: "#ffffff",
                borderRadius: "12px",
                padding: "16px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06), 0 1px 3px rgba(0,0,0,0.04)",
                border: "1px solid rgba(0,0,0,0.06)",
                margin: "16px 0",
              }}
            >
              {/* Titre de section */}
              <div
                style={{
                  fontSize: "12px",
                  fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                  fontWeight: 600,
                  color: "#1f2937",
                  margin: "0 0 8px 0",
                  letterSpacing: "-0.02em",
                  borderBottom: "1px solid rgba(0,0,0,0.1)",
                  paddingBottom: "8px",
                }}
              >
                Cotisations productives en matière de retraite
              </div>

              {/* En-têtes de colonnes */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "15px",
                  marginTop: "12px",
                  paddingLeft: "12px",
                  paddingRight: "12px",
                }}
              >
                <div
                  style={{
                    flex: "1",
                    color: "#1f2937",
                    fontWeight: "bold",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                ></div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  }}
                >
                  <div
                    style={{
                      width: "80px",
                      color: "#1f2937",
                      fontWeight: "bold",
                      fontSize: "12px",
                      textAlign: "right",
                    }}
                  >
                    Avant
                  </div>
                  <div
                    style={{
                      width: "80px",
                      color: "#1f2937",
                      fontWeight: "bold",
                      fontSize: "12px",
                      textAlign: "right",
                    }}
                  >
                    Après
                  </div>
                </div>
              </div>

              {/* Cartes financières compactes */}
              <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                <CompactFinancialCardTwoColumn
                  title="Cotisations de retraite obligatoire"
                  valueClient={applyFormat(cotProductiveRetraiteObligatoireAvant, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                  valueConjoint={applyFormat(cotProductiveRetraiteObligatoireApres, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                  labelClient=""
                  labelConjoint=""
                  icon={<FaChartLine style={{ color: "#2563eb" }} />}
                  accentColor="#2563eb"
                />

                <CompactFinancialCardTwoColumn
                  title="Cotisations de retraite facultative"
                  valueClient={applyFormat(cotProductiveRetraiteFacultativeAvant, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                  valueConjoint={applyFormat(cotProductiveRetraiteFacultativeApres, "uint", { thousands: " ", decimal: ",", unit: " €" })}
                  labelClient=""
                  labelConjoint=""
                  icon={<FaChartLine style={{ color: "#7c3aed" }} />}
                  accentColor="#7c3aed"
                />
              </div>
            </div>
              <Row>
              <Column fill>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                    padding: "12px",
                    background: "linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(248,250,252,0.98) 100%)",
                    borderRadius: "12px",
                    boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                    border: "1px solid rgba(255,255,255,0.9)",
                  }}
                >
                  {/* Titre du premier groupe */}
                  <div
                    style={{
                      fontSize: "12px",
                      fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                      fontWeight: 600,
                      color: "#1f2937",
                      marginBottom: "4px",
                      letterSpacing: "-0.02em",
                      borderBottom: "1px solid rgba(0,0,0,0.1)",
                      paddingBottom: "8px",
                    }}
                  >
                    Gestion de la simulation
                  </div>
                  {/* Première ligne - 2 boutons */}
                  <div style={{ display: "flex", gap: "8px" }}>
                    <ActionButton
                      variant="primary"
                      icon={<FaUndo />}
                      title="Réinitialiser"
                      subtitle="Restaurer les valeurs initiales"
                      onClick={() => context.handleOpenRemiseDonneeRemExpressOptirem(ResultatTNS)}
                    />

                    <ActionButton
                      variant="success"
                      icon={<FaPrint />}
                      title="Impression"
                      subtitle="Editer un pptx"
                      onClick={() => {
                        GestionnaireScenarioPptx(context.state, ResultatTNS.state).then((res) => {});
                      }}
                    />
                  </div>

                  {/* Deuxième ligne - 2 boutons */}
                  <div style={{ display: "flex", gap: "8px" }}>
                    {context.state.Partner !== "KWIPER" && (
                      <ActionButton
                        variant="info"
                        icon={<FaSave />}
                        title="Sauvegarder"
                        subtitle="Sauvegarder la simulation"
                        onClick={() => setModalSave(true)}
                      />
                    )}
                    
                    <ActionButton
                      variant="danger"
                      icon={<FaRobot />}
                      title="Quitter"
                      subtitle="Revenir aux simulations"
                      onClick={() => {
                        props.onClose();
                      }}
                    />
                  </div>
                </div>
                <Modal
                  width="450px"
                  height="25%"
                  title="Sauvegarde de la simulation"
                  icon={<FaSave />}
                  visible={modalSave}
                  onClose={() => {
                    setModalSave(false);
                  }}
                >
                  <Column fill>
                    <Row fill center>
                      <Column fill center>
                        <TextField
                          labelStyle={{ color: "var(--app-fg-color)" }}
                          label="Libellé de la simulation"
                          value={context.state.LibelleOptimisation}
                          onChange={context.handleInputChange("LibelleOptimisation")}
                          style={{ width: "370px" }}
                        />
                      </Column>
                    </Row>
                    <Row className="pager-buttons">
                      <Column fill>
                        <Button
                          onClick={() => {
                            // context.handleNewSimulation("Audit prévoyance");
                            context.handleSaveAsOptimisation(context.state.IdOptimisation, "OptiRem");
                            setModalSave(false);
                          }}
                        >
                          <span>Enregistrer</span>
                        </Button>
                      </Column>
                      <Column fill>
                        <Button
                          onClick={() => {
                            context.handleSaveAsOptimisation("", "OptiRem");
                            // context.handleNewSimulation("Audit prévoyance");
                            setModalSave(false);
                          }}
                        >
                          <span>Enregistrer sous</span>
                        </Button>
                      </Column>
                    </Row>
                  </Column>
                </Modal>
              </Column>
            </Row>

          </Column>
        </Row>
      </Column>

      {/* MODAL OPTIMUM */}
      <Modal
        width="40%"
        height="50%"
        title="Optimum"
        icon={<FaGlobe />}
        visible={modalOptimum}
        onClose={() => {
          setModalOptimum(false);
        }}
      >
        <Pager
          pages={[
            {
              content: (
                <Column fill>
                  <CardBox>
                    <Column fill>
                      <Row bpad>
                        <DropDown
                          label="Optimum"
                          value={context.state.OptiRemChoixOptimum}
                          onChange={context.handleInputChange("OptiRemChoixOptimum")}
                          options={[
                            { value: "automatique", label: "Maximiser le revenu disponible" },
                            { value: "manu", label: "Optimum avec rémunération minimale" },
                          ]}
                          large
                        />
                      </Row>
                      {context.state.OptiRemChoixOptimum === "manu" && (
                        <Row tpad>
                          <TextField
                            label="Rémunération nette minimale"
                            value={context.state.OptiRemOptimumRemMini}
                            onChange={context.handleInputChange("OptiRemOptimumRemMini")}
                            dataType="uint"
                            format={{ thousands: " ", unit: " €" }}
                            large
                          />
                        </Row>
                      )}
                    </Column>
                  </CardBox>
                </Column>
              ),
            },
          ]}
          page={0}
          navButtons={{
            validate: {
              onClick: (evt) => {
                setModalOptimum(false);
                context.handleValueChange("OptiRemLoading", true);
                context.handleCalculOptiRem("optimum", "", "", ResultatTNS, false, false);
              },
            },
          }}
        />
      </Modal>
      {/* MODAL CHANGEMENT STATUT */}
      <Modal
        width="50%"
        height="70%"
        title="Changement de statut"
        icon={<FaGlobe />}
        visible={modalChgtStatut}
        onClose={() => {
          setModalChgtStatut(false);
        }}
      >
        <Pager
          pages={[
            {
              content: (
                <Column fill>
                  <CardBox>
                    <Column fill>
                      <Row bpad>
                        <InfoMessage text="Par défaut, le logiciel raisonne à budget équivalent. Ce parti pris peut être modifié dans les champs de la nouvelle situation." />
                      </Row>
                      {context.state.PeriodeActuelle[0]?.StatutConjoint !== "Aucun" && (
                        <Row bpad>
                          <Column bpad>
                            <DropDown
                              label="Etude réalisé pour"
                              value={context.state.OptiRemCDSEtude}
                              options={[
                                {
                                  value: "client",
                                  label: context.state.Prenom,
                                },
                                {
                                  value: "conjoint",
                                  label: context.state.PrenomConjoint,
                                },
                                {
                                  value: "both",
                                  label: "Les deux",
                                },
                              ]}
                              onChange={context.handleInputChange("OptiRemCDSEtude")}
                              normal
                            />
                          </Column>
                        </Row>
                      )}
                      {(context.state.PeriodeActuelle[0]?.StatutConjoint === "Aucun" ||
                        (context.state.PeriodeActuelle[0]?.StatutConjoint !== "Aucun" && context.state.OptiRemCDSEtude !== "conjoint")) && (
                        <>
                          <Row>
                            <h1>Changement de statut de {context.state.Prenom}</h1>
                          </Row>
                          <Row>
                            <Column>
                              <DropDown
                                label="Statut social"
                                value={context.state.OptiRemCDSStatut}
                                options={
                                  context.state.PeriodeActuelle[0]?.Statut === "TNS Article 62"
                                    ? [
                                        {
                                          value: "Assimilé salarié",
                                          label: "Assimilé salarié",
                                        },
                                      ]
                                    : context.state.PeriodeActuelle[0]?.Statut === "TNS individuel"
                                    ? [
                                        {
                                          value: "TNS Article 62",
                                          label: "TNS Article 62",
                                        },
                                        {
                                          value: "TNS individuel",
                                          label: "TNS individuel",
                                        },
                                        {
                                          value: "Assimilé salarié",
                                          label: "Assimilé salarié",
                                        },
                                      ]
                                    : [
                                        {
                                          value: "TNS Article 62",
                                          label: "TNS Article 62",
                                        },
                                      ]
                                }
                                onChange={context.handleInputChange("OptiRemCDSStatut")}
                                normal
                              />
                            </Column>
                          </Row>
                          {(context.state["OptiRemCDSStatut"] === "TNS Article 62" || context.state["OptiRemCDSStatut"] === "TNS individuel") && (
                            <Row tpad>
                              <Column>
                                <DropDown
                                  label="Caisse d'affiliation"
                                  value={context.state.OptiRemCDSCaisse}
                                  options={caisse}
                                  onChange={context.handleInputChange("OptiRemCDSCaisse")}
                                  normal
                                />
                              </Column>
                              {context.state["OptiRemCDSStatut"] === "TNS individuel" && (
                                <Column>
                                  <DropDown
                                    label="MODE D'EXERCICE"
                                    value={"IS"}
                                    options={[
                                      {
                                        value: "IS",
                                        label: "En société à l'IS",
                                      },
                                    ]}
                                    // onChange={context.handleInputChange("OptiRemCDSCaisse")}
                                    disabled
                                    normal
                                  />
                                </Column>
                              )}
                            </Row>
                          )}
                          {context.state["OptiRemCDSStatut"] === "TNS individuel" && (
                            <Row tpad>
                              <Column>
                                <TextField
                                  label="% rémunération du mandat"
                                  value={context.state.OptiRemPartRemunerationMandat}
                                  onChange={context.handleInputChange("OptiRemPartRemunerationMandat")}
                                  dataType="uint"
                                  format={{ thousands: " ", unit: "%" }}
                                  normal
                                />
                              </Column>
                            </Row>
                          )}

                          {(context.state["OptiRemCDSStatut"] === "TNS Article 62" || context.state["OptiRemCDSStatut"] === "TNS individuel") && (
                            <>
                              {context.state.OptiRemCDSCaisse === "Carcdsf" && <ParamCarcdsf Outil="OptiRem" ClientConjoint="" />}
                              {context.state.OptiRemCDSCaisse === "Carcdsf2" && <ParamCarcdsf Outil="OptiRem" ClientConjoint="" />}
                              {context.state.OptiRemCDSCaisse === "Carmf" && <ParamCarmf Outil="OptiRem" ClientConjoint="" />}
                              {context.state.OptiRemCDSCaisse === "Carpimko" && <ParamCarpimko Outil="OptiRem" ClientConjoint="" />}
                              {context.state.OptiRemCDSCaisse === "Carpv" && <ParamCarpv Outil="OptiRem" ClientConjoint="" />}
                              {context.state.OptiRemCDSCaisse === "Cavec" && <ParamCavec Outil="OptiRem" ClientConjoint="" />}
                              {context.state.OptiRemCDSCaisse === "Cavamac" && <ParamCavamac Outil="OptiRem" ClientConjoint="" />}
                              {context.state.OptiRemCDSCaisse === "Cavp" && <ParamCavp Outil="OptiRem" ClientConjoint="" />}
                              {/* {context.state.Caisse === "Cipav" && <ParamCipav Outil="" ClientConjoint="" />} */}
                              {context.state.OptiRemCDSCaisse === "Cnbf" && (
                                <>
                                  <ParamCnbf Outil="OptiRem" ClientConjoint="" />
                                  <Row tpad>
                                    <Column>
                                      <ParamLpaPageModal Outil="OptiRem" ClientConjoint="" />
                                    </Column>
                                  </Row>
                                </>
                              )}
                              {context.state.OptiRemCDSCaisse === "Crn" && <ParamCrn Outil="OptiRem" ClientConjoint="" />}
                              {context.state.OptiRemCDSCaisse === "Msa" && <ParamMsa Outil="OptiRem" ClientConjoint="" />}
                            </>
                          )}

                          {/* <Row tpad bpad>
                            <Column>
                              <DropDown
                                label="Raisonnement"
                                value={context.state.OptiRemCDSRaisonnement}
                                options={[
                                  {
                                    value: "cout_remuneration",
                                    label: "A budget équivalent",
                                  },
                                  {
                                    value: "remuneration_nette",
                                    label: "A rémunération nette équivalente",
                                  },
                                ]}
                                onChange={context.handleInputChange("OptiRemCDSRaisonnement")}
                                normal
                              />
                            </Column>
                          </Row> */}
                          {context.state.OptiRemCDSStatut === "Assimilé salarié" && (
                            <Row tpad bpad>
                              <ParamFicheDePaiePageModal Outil="OptiRem" ClientConjoint="" />
                            </Row>
                          )}
                        </>
                      )}
                    </Column>
                  </CardBox>
                </Column>
              ),
            },
          ]}
          page={0}
          navButtons={{
            validate: {
              onClick: (evt) => {
                setModalChgtStatut(false);
                context.handleChangementStatut("", ResultatTNS);
              },
            },
          }}
        />
        {console.log("context.state.OptiRemCDSStatut", ResultatTNS.state.OptiRemDetailImpot)}
      </Modal>
      {/* MODAL DETAIL CLIENT */}
      <Modal
        width="80%"
        height="82%"
        title="Details"
        icon={<FaIdBadge />}
        visible={modalDetail}
        onClose={() => {
          setModalDetail(false);
        }}
      >
        {Periode?.Statut === "TNS Article 62" || Periode?.Statut === "TNS individuel" ? (
          <DetailTNSPageModal
            AccessRemExpress={true}
            Outil=""
            ClientConjoint=""
            Prenom={Prenom}
            Caisse={Periode?.Caisse}
            DetailImpot={ResultatTNS.state.OptiRemDetailImpot}
            GraphPerp={ResultatTNS.state.OptiRemDetailImpot?.GraphPerp}
             InfosPerp={ResultatTNS.state.OptiRemDetailImpot?.InfosPerp}
            GraphDisponible={ResultatTNS.state["OptiRemRemuneration"].GraphDisponible}
            DetailCotisations={ResultatTNS.state["OptiRemRemuneration"].DetailCotisations}
            InfosDisponible={ResultatTNS.state["OptiRemRemuneration"].Rapport.DispoDepaMadelin}
            DetailAssiette={ResultatTNS.state["OptiRemRemuneration"].DetailAssiette}
            DetailCSG={ResultatTNS.state["OptiRemRemuneration"].DetailCSG}
            TotalChargesSociales={ResultatTNS.state["OptiRemRemuneration"].TotalChargesSociales}
            DetailAssietteClient={ResultatTNS.state["OptiRemRemuneration"].DetailAssiette}
            visible={modalDetail}
            onClose={() => {
              setModalDetail(false);
            }}
          />
        ) : (
          <DetailSalariePageModal
            AccessRemExpress={true}
            Outil=""
            Prenom={Prenom}
            ClientConjoint=""
            DetailImpot={ResultatTNS.state.OptiRemDetailImpot}
             InfosPerp={ResultatTNS.state.OptiRemDetailImpot?.InfosPerp}
            GraphPerp={ResultatTNS.state.OptiRemDetailImpot?.GraphPerp}
            DetailFicheDePaie={ResultatTNS.state["OptiRemRemuneration"].DetailFicheDePaie}
            DetailAssietteClient={ResultatTNS.state["OptiRemRemuneration"].DetailFicheDePaie}
            GraphDisponible={ResultatTNS.state["OptiRemRemuneration"].GraphDisponible}
             InfosDisponible={ResultatTNS.state["OptiRemRemuneration"]?.Rapport?.InfosDisponible}
            visible={modalDetail}
            onClose={() => {
              setModalDetail(false);
            }}
          />
        )}
      </Modal>
    </>
  );
};

export default RemExpressOptiRemPage;
